import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import './main.css';
import { Provider } from 'react-redux';
import { configureStore } from './redux/store';
import Amplify from "aws-amplify";
import config from "./config";
import { BrowserRouter as Router } from 'react-router-dom';

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
  },
  Storage: {
    bucket: config.s3.BUCKET,
    region: config.s3.REGION,
  },
  // Add the API Gateway
  API : {
    endpoints: [
      {
        name: "photos",
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      }
    ]
  },
});


ReactDOM.render(
  <Provider store={configureStore()}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
